<template>
  <div class="checkin">
    <checkin-stepper/>
    <v-container class="checkin">
      <v-card>
        <v-card-text>
          <OrderConclusionForm
            :order="order"
            :reservation="reservation"
            v-if="!loading"
            @form:completed="handleFormCompleted"
          />
          <div v-if="loading" class="text-center">
            <v-progress-circular
              size="50"
              color="primary"
              indeterminate
            />
          </div>
        </v-card-text>

        <checkin-bottom-navigation>
          <template v-slot:prev-button>
            <v-btn @click="goToPrevStepper">
              {{ $t("commons.prev") }}
            </v-btn>
          </template>
          <template v-slot:next-button
          v-if = "!isTheEnd">
            <v-btn
              @click="goToNextStepper()"
              :disabled="!isFormCompleted"
              color="primary"
            >
              {{ $t("commons.next") }}
            </v-btn>
          </template>
          <template v-slot:next-button
          v-else>
            <v-btn
              v-if="formAndMandatoryStepsCompleted"
              @click="completeCheckin()"
              :disabled="!isFormCompleted"
              color="success"
              :loading='submitting'
            >
              {{ $t("commons.end") }}
            </v-btn>
            <v-btn
              v-else
              @click="completeCheckin()"
              color="primary"
              :disabled="!isFormCompleted"
              :loading='submitting'
            >
              {{ $t("commons.close_checkin") }}
            </v-btn>
          </template>
        </checkin-bottom-navigation>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CheckinStepper from '../../checkin/checkin_stepper'
  import CheckinBottomNavigation from '../../checkin/checkin_bottom_navigation'
  import OrderConclusionForm from '../../orders/order_conclusion_form'
  import { orderFetchMixin } from '../../../mixins/order_fetch_mixin'
  import { orderMethodsMixin } from '../../../mixins/order_methods_mixin'

  export default {
    name: "CheckinSummary",

    components: {
      CheckinStepper,
      OrderConclusionForm,
      CheckinBottomNavigation
    },

    mixins: [
      orderFetchMixin,
      orderMethodsMixin,
    ],

    data() {
      return {
        isFormCompleted: false
      }
    },

    created() {
      this.fetchOrder(this.currentOrderId, this.getFreshOrder)
    },

    updated () {
      // Casi in cui entra
      // Caso 1: quando c'è il riconoscimenti E la pratica è in signing
      if(this.reservation.guests_recognition==true &&  this.reservation.customer_contract_state == "signing") {
        this.$router.push({name: 'checkinContract'})
      }
    },

    computed: {
      ...mapState('layout', ['loading', 'currentStep', 'submitting', 'completedCheckinSteps']),
      ...mapState('order', ['order']),
      formAndMandatoryStepsCompleted() {
        return this.completedCheckinSteps && this.completedCheckinSteps.every((step) => step.completed )
      },
      presenceRemovableSteps() {
        return this.completedCheckinSteps.some(step => ['contract', 'payment', 'recognition'].includes(step.name))
      },
      isTheEnd() {
        return !!this.reservation && !this.presenceRemovableSteps
      }
    },

    methods: {
      ...mapActions('layout', ['goToPrevStepper','goToNextStepper']),
      handleFormCompleted() {
        this.isFormCompleted = true
      },
    }
  }
</script>
